module.exports = __webpack_public_path__ + "img/upImage.ab003a15.svg";